module.exports = __webpack_public_path__ + "static/media/logomubon_compuesto.36650d9f.png";